import client from '@/api/client.js';
//import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        //get report data
        async getTimeReport(dto) {
            var meta = { clientApiMethod: 'getTimeReport', input: { dto: dto } };
            var response = await client().get(`${store.state.apiRouteRoot}TimeReport`, { params: dto, meta: meta });
            return response.data;
        },

        //add row
        async createTimeReportRow(dto) {
            var meta = { clientApiMethod: 'createTimeReportRow', input: { dto: dto } };
            var response = await client().post(`${store.state.apiRouteRoot}TimeReport/Row`, dto, { meta: meta });
            return response.data;
        },

        //change row
        async updateTimeReportRow(dto) {
            var meta = { clientApiMethod: 'updateTimeReportRow', input: { dto: dto } };
            var response = await client().patch(`${store.state.apiRouteRoot}TimeReport/Row`, dto, { meta: meta });
            return response.data;
        },

        //delete row
        async deleteTimeReportRow(row) {
            var meta = { clientApiMethod: 'deleteTimeReportRow', input: { row: row } };
            var response = await client().delete(`${store.state.apiRouteRoot}TimeReport/Row`, { params: row, meta: meta });
            return response.data;
        },

        //export to excel
        async exportTimeReport(dto) {
            var meta = { clientApiMethod: 'exportTimeReport', input: { dto: dto } };
            var response = await client().post(`${store.state.apiRouteRoot}TimeReport/Export`, dto, { meta: meta });
            return response.data;
        },

		//test time reporting calculation
		async testTimeReporting(dto) {
			var meta = { clientApiMethod: 'testTimeReporting', input: { dto: dto } };
			var response = await client().post(`${store.state.apiRouteRoot}TimeReport/Test`, dto, { meta: meta });
			return response.data;
		},
    }
}